import httpClient from '../utils/httpClient';

export const styleSearch = async (requestParams) => {
    const response = await httpClient.post('/Jewellery/styleSearch', requestParams);
    return response.data;
};

export const styleSearchDetail = async (requestParams) => {
    const response = await httpClient.post('/Jewellery/StyleSearchDetail', requestParams);
    return response.data;
};

export const getDiamondTypeClarity = async (requestParams) => {
    const response = await httpClient.post('/Jewellery/GetDiamondTypeClarity', requestParams);
    return response.data;
};